import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router";
import InfiniteScroll from "react-infinite-scroll-component";
import SearchIcon from "../../../assets/img/svg/searchicon.svg";
import {
  CreateJobFeedList,
  getSearchJobListByQuery,
} from "../../../redux/action/creator/CreatorJob";
import BubblesLoader from "../../common/BubblesLoader";
import EmptyCard from "../../common/EmptyCard";
import JobDetails from "../../common/JobDetails";

const RecentJob = ({ history }) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  const creatorJobList = useSelector((state) => state.jobs.creatorJobList);
  const creatorSearchJobList = useSelector(
    (state) => state.jobs.creatorSearchJobList
  );

  const pageChangeHandler = () => {
    setPage(page + 1);
  };

  useEffect(() => {
    const types = "approved";
    const shortedValue = 0;
    dispatch(
      CreateJobFeedList(types, setLoading, shortedValue, page, setHasMore)
    );
  }, [dispatch, page]);

  const handleSearchJob = (value) => {
    const types = "approved";
    setSearchValue(value);
    if (searchValue) {
      dispatch(getSearchJobListByQuery(setLoading, types, searchValue));
    }
  };

  const handleShorting = (shortedValue) => {
    const types = "approved";
    dispatch(
      CreateJobFeedList(types, setLoading, shortedValue, page, setHasMore)
    );
  };

  const jobListArrayLength =
    searchValue === ""
      ? creatorJobList && creatorJobList.length
      : creatorSearchJobList && creatorSearchJobList.length;

  const jobListArray =
    page === 0 && loading ? (
      <div className="h-100 d-flex justify-content-center align-items-center w-100 flex-column">
        <BubblesLoader />
        <p className="pt-3 common-heading-Medium  f-w-600 text-black md-font">
          Please wait...
        </p>
      </div>
    ) : searchValue === "" ? (
      creatorJobList && !!creatorJobList.length ? (
        creatorJobList.map((item, index) => {
          return (
            <JobDetails
              item={item}
              index={index}
              history={history}
              type="creator/job-view/details"
              loading={loading}
            />
          );
        })
      ) : (
        <EmptyCard message={"You’ve not any Recent Jobs List Yet!"} />
      )
    ) : creatorSearchJobList && !!creatorSearchJobList.length ? (
      creatorSearchJobList.map((item, index) => {
        return (
          <JobDetails
            item={item}
            index={index}
            history={history}
            type="creator/job-view/details"
          />
        );
      })
    ) : (
      <div className="w-100">
        <EmptyCard message={"You’ve not any Recent Jobs List Yet!"} />
      </div>
    );

  return (
    <div className="container-fluid">
      <div className="row align-items-center justify-content-between my-sm-4 my-2">
        <div className="col-xxl-4 col-md-6">
          <div className="search-field position-relative">
            <input
              type="email"
              className="form-control"
              placeholder="Search for job..."
              aria-describedby="emailHelp"
              onChange={(e) => handleSearchJob(e.target.value)}
              name="query"
            />
            <img className="search-icon" src={SearchIcon} alt="SearchIcon" />
          </div>
        </div>
        <div className="col-xxl-3 col-md-5 d-flex  flex-sm-row flex-column ">
          <div className=" select-field  w-100 mt-md-0 mt-3">
            <select
              className="form-select py-2 cursor-pointer px-3"
              onChange={(e) => handleShorting(e.target.value)}
            >
              <option>Sorting</option>
              <option value="0">Recently Added</option>
              <option value="1">Recently Updated</option>
            </select>
          </div>
        </div>
      </div>
      <div className="mt-4 card-scroll admin_job" id="recent-jobs-list">
        <div className="infinite_scroll h-100 row">
          <InfiniteScroll
            className={`${
              jobListArrayLength === 0 || loading
                ? " h-100 justify-content-center"
                : "   d-flex  flex-column flex-xxl-row"
            } `}
            dataLength={jobListArrayLength}
            next={pageChangeHandler}
            hasMore={hasMore}
            scrollableTarget="recent-jobs-list"
            loader={
              page > 0 && loading ? (
                <div className="h-100 d-flex justify-content-center w-100 align-items-center flex-column">
                  <BubblesLoader />
                </div>
              ) : (
                ""
              )
            }
          >
            {jobListArray}
          </InfiniteScroll>
        </div>
      </div>
    </div>
  );
};

export default withRouter(RecentJob);
